/* eslint-disable react/prop-types */
import React, { useState, useContext, useEffect } from "react";
import Select, { components } from "react-select";
import { Modal } from "react-bootstrap";
import axios from "axios";
import "PostVisibilityOptionsModal/styles.scss";
import BeatLoader from "react-spinners/BeatLoader";
import { toast } from "ToastAlertContainer";
import { generalUtils } from "utilities";
import {
  usePostSharingSettings,
  usePatchPostSharingSettings,
} from "queryHooks";
import Switch from "Switch";

const PostVisibilityOptionsModal = ({
  show,
  className,
  companyId,
  companyName,
  postId,
  post,
  handleUpdatePost,
  contactGroups,
  selectedContactGroups,
  setSelectedContactGroups,
  initialGroups,
  setInitialGroups,
  setShowPostVisibilityOptionsModal,
}) => {
  const [showProfileDisplayOption, setShowProfileDisplayOption] = useState({
    value: "public",
  });

  const [saving, setSaving] = useState(false);

  const {
    data: postSharingSettings = {},
    status: postSharingSettingsStatus,
    error: postSharingSettingsError,
  } = usePostSharingSettings({ companyId, postId });

  const {
    mutateAsync: patchPostSharingSettings,
    error: patchPostSharingSettingsError,
    status: patchPostSharingSettingsStatus,
    // isLoading: patchIsLoading,
  } = usePatchPostSharingSettings();

  const handleGenerateNewShareableLink = async () => {
    let settings = {
      generate_new_private_shared_hash: true,
    };

    let generateNewShareabelLinkResult;

    try {
      generateNewShareabelLinkResult = await patchPostSharingSettings({
        companyId,
        postId,
        postSharingSettings: settings,
      });
    } catch (err) {
      console.error(err.response.data);
    }
  };

  const handleToggleShareableLink = async () => {
    let settings = {
      private_shared_link_enabled:
        !postSharingSettings.private_shared_link_enabled,
    };

    let generateNewShareabelLinkResult;

    try {
      generateNewShareabelLinkResult = await patchPostSharingSettings({
        companyId,
        postId,
        postSharingSettings: settings,
      });
    } catch (err) {
      console.error(err.response.data);
    }
  };

  const handleToggleAllowAccessByEmail = async (checked) => {
    let settings = {
      allow_access_by_email: checked,
    };

    let generateNewShareabelLinkResult;

    try {
      generateNewShareabelLinkResult = await patchPostSharingSettings({
        companyId,
        postId,
        postSharingSettings: settings,
      });
    } catch (err) {
      console.error(err.response.data);
    }
  };

  const handleCopyLinkToClipboard = (string) => {
    navigator.clipboard.writeText(string);
    toast.success("Link copied to clipboard");
  };

  useEffect(() => {
    if (post.visibility) {
      post.visibility =
        post.visibility == "private" ? "recipients_only" : post.visibility;

      setShowProfileDisplayOption(
        profileDisplayOptions.find((x) => x.value === post.visibility)
      );
    }
  }, [post]);

  let hostedUpdateUrl = generalUtils.generateHostedUpdateSlug(
    window.location.origin,
    companyName,
    post.title,
    post.post_id
  );

  const handleClose = () => {
    setShowPostVisibilityOptionsModal(false);
    setShowProfileDisplayOption(
      profileDisplayOptions.find((option) => option.value === post.visibility)
    );
    setSelectedContactGroups(initialGroups);
  };

  const customStyles = {
    control: (base) => ({
      ...base,
      height: 40,
      minHeight: 40,
    }),
    valueContainer: (base) => ({
      ...base,
      height: "100%",
    }),
    input: (base) => ({
      ...base,
      height: "100%",
    }),
  };

  const Option = (props) => {
    return (
      <components.Option {...props}>
        <div>{props.data.label}</div>
        <div style={{ fontSize: 12 }}>{props.data.subLabel}</div>
      </components.Option>
    );
  };
  const SingleValue = (props) => (
    <components.SingleValue
      {...props}
      style={{
        padding: "5px",
      }}
    >
      <div>{props.data.label}</div>
      <div style={{ fontSize: 12 }}>{props.data.subLabel}</div>
    </components.SingleValue>
  );
  const profileDisplayOptions = [
    {
      label: "Public",
      // subLabel: "Anyone on or off Paperstreet can view this Update.",
      value: "public",
    },
    {
      label: "Contact Groups",
      // subLabel: "Only show to specified contact groups.",
      value: "contact_groups",
    },
    {
      label: "Recipients Only",
      // subLabel: "Only show to people you've sent this to.",
      value: "recipients_only",
    },
    {
      label: "Hidden",
      // subLabel:
      // "Not displayed. Only accesible by your admins via the Updates page.",
      value: "hidden",
    },
  ];

  const showShareableLinkSection = () => {
    if (showProfileDisplayOption.value === "recipients_only") {
      return true;
    }

    if (showProfileDisplayOption.value === "contact_groups") {
      return true;
    }

    return false;
  };

  if(!postSharingSettings){
    return null;
  }

  return (
    <div>
      <Modal
        className={className}
        show={show}
        centered
        keyboard
        onHide={handleClose}
        animation={false}
        // title="Sharing & Privacy Options"
      >
        <div className="ps-post-visibility-options-modal__cancel-icon-container">
          <button
            onClick={handleClose}
            style={{
              width: "32x",
              height: "32px",
            }}
            className="ps-btn--round-remove ps-btn--round-remove__modal"
          ></button>
        </div>
        <div className="ps-post-visibility-options-modal__title-container">
          <div className="ps-post-visibility-options-modal__title">
            Share this update
          </div>
        </div>
        {/* <hr className="ps-divider--secondary ps-divider--full-width m-0" /> */}
        <Modal.Body className="ps-post-visibility-options-modal__body">
          <div>
            <div
              style={{
                backgroundColor: "#f6f6f6",
                padding: "16px 18px",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <div style={{ flex: 2 }}>
                  <div style={{ fontSize: "15px", fontWeight: "500" }}>
                    {showProfileDisplayOption.value === "public" && `Public`}
                    {showProfileDisplayOption.value === "recipients_only" &&
                      `Restricted link`}
                    {showProfileDisplayOption.value === "contact_groups" &&
                      `Restricted link`}
                    {showProfileDisplayOption.value === "hidden" &&
                      `Unlisted link`}
                  </div>
                  <div style={{ fontSize: "13px" }}>
                    {showProfileDisplayOption.value === "public" &&
                      `Anyone with the following link can view this update. This update is indexed and discoverable by search engines.`}
                    {showProfileDisplayOption.value === "recipients_only" &&
                      `Logged in users that have access to your update will be able to view it on Paperstreet with the following link.`}
                    {showProfileDisplayOption.value === "contact_groups" &&
                      `Logged in users that have access to your update will be able to view it on Paperstreet with the following link.`}
                    {showProfileDisplayOption.value === "hidden" &&
                      `Only your company admins can access this link.`}
                  </div>
                </div>
                <div style={{ flex: 1, width: "100%", marginLeft: "25px" }}>
                  <Select
                    className="ps-post-visibility-options-modal__select-form-group"
                    options={profileDisplayOptions}
                    components={{ Option, SingleValue }}
                    onChange={async (value) => {
                      setShowProfileDisplayOption(value);
                    }}
                    value={showProfileDisplayOption}
                    styles={customStyles}
                    isSearchable={false}
                  />
                </div>
              </div>

              {showProfileDisplayOption.value === "contact_groups" && (
                <div
                  className={
                    "ps-post-visibility-options-modal__select-form-group"
                  }
                  style={{ marginTop: "15px" }}
                >
                  {/* <label
                    className="ps-post-visibility-options-modal__contact-group-label"
                    htmlFor=""
                  >
                    Contact Groups
                  </label> */}
                  <Select
                    placeholder="Select contact group(s)"
                    type="text"
                    name="visibility"
                    isMulti={true}
                    value={selectedContactGroups}
                    onChange={(value) => {
                      setSelectedContactGroups(value);
                    }}
                    options={contactGroups}
                  ></Select>
                </div>
              )}
            </div>

            <div>
              <div>
                <div
                  style={{
                    marginTop: "20px",
                    backgroundColor: "#E9F1FF",
                    borderRadius: "3px",
                    fontSize: "12px",
                    padding: "15px",
                    color: "#266EFF",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      overflow: "hidden",
                      whiteSpace: "nowrap",
                      textOverflow: "ellipsis",
                    }}
                  >
                    {hostedUpdateUrl}
                  </div>
                  <div
                    style={{
                      backgroundColor: "#E9F1FF",
                      paddingLeft: "50px",
                      fontSize: "13px",
                      fontWeight: "500",
                      whiteSpace: "nowrap",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      let link = hostedUpdateUrl;
                      handleCopyLinkToClipboard(link);
                    }}
                  >
                    Copy link
                  </div>
                </div>

                {showShareableLinkSection() === true && (
                  <div
                    style={{
                      marginTop: "18px",
                      marginBottom: "30px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "flex-start",
                      }}
                    >
                      <Switch
                        defaultChecked={postSharingSettings.allow_access_by_email}
                        onChange={(event) => {
                          handleToggleAllowAccessByEmail(event.target.checked);
                        }}
                      />
                      <div
                        style={{
                          marginLeft: "10px",
                          fontSize: "12px",
                          color: "#1C2433",
                        }}
                      >
                        If allowed access via update privacy, enable logged out
                        users to view by providing their email
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>

            {showShareableLinkSection() === true && (
              <div
                style={{
                  padding: "16px 18px",
                  borderRadius: "3px",
                  border: "1px solid #EBEDF1",
                }}
              >
                <div
                  style={{
                    fontSize: "15px",
                    fontWeight: "500",
                    marginBottom: "5px",
                  }}
                >
                  Shareable link
                </div>
                <div style={{ marginBottom: "10px" }}>
                  Anyone with the shareable link can view this update.
                </div>

                {postSharingSettings.private_shared_link_enabled === false && (
                  <button
                    className="btn ps-btn--primary ps-btn--auto-width"
                    onClick={() => {
                      handleToggleShareableLink();
                    }}
                  >
                    Generate Shareable Link
                  </button>
                )}

                {postSharingSettings.private_shared_link_enabled === true && (
                  <div>
                    <div>
                      <div
                        style={{
                          backgroundColor: "#FEEDED",
                          borderRadius: "3px",
                          padding: "15px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",

                          color: "#EF4444",
                        }}
                      >
                        <div
                          style={{
                            overflow: "hidden",
                            whiteSpace: "nowrap",
                            textOverflow: "ellipsis",
                            fontSize: "12px",
                          }}
                        >
                          {hostedUpdateUrl}/
                          {postSharingSettings.private_shared_link_hash}
                        </div>
                        <div
                          style={{
                            backgroundColor: "#FEEDED",
                            paddingLeft: "50px",
                            fontSize: "13px",
                            fontWeight: "500",
                            whiteSpace: "nowrap",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            let link =
                              hostedUpdateUrl +
                              "/" +
                              postSharingSettings.private_shared_link_hash;
                            handleCopyLinkToClipboard(link);
                          }}
                        >
                          Copy link
                        </div>
                      </div>
                    </div>
                    <div
                      style={{
                        marginTop: "20px",
                        display: "flex",
                      }}
                    >
                      <button
                        onClick={() => {
                          handleGenerateNewShareableLink();
                        }}
                        className="btn ps-btn--primary ps-btn--auto-width"
                      >
                        Generate New Shareable Link
                      </button>
                      <div
                        className="btn ps-btn--white ps-btn--auto-width"
                        style={{ marginLeft: "10px" }}
                        onClick={() => {
                          handleToggleShareableLink();
                        }}
                      >
                        Disable Shareable Link
                      </div>
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
          <button
            className="ps-post-visibility-options-modal__save-button btn ps-btn--primary"
            onClick={async () => {
              setSaving(true);
              let savePostResult;
              let update = {
                visibility: showProfileDisplayOption.value,
              };

              try {
                savePostResult = await axios.patch(
                  "/api/v2/companies/" + companyId + "/posts/" + postId,
                  update
                );
              } catch (err) {
                console.log(err.stack);
              }
              if (handleUpdatePost) {
                handleUpdatePost(savePostResult.data);
              }
              try {
                let eventProperties = {
                  companyID: companyId,
                  postId: postId,
                  companyName: companyName,
                  value: showProfileDisplayOption.value,
                };
                PSBase.analytics.logAmplitudeEvent(
                  "post privacy settings: edited post visibility",
                  eventProperties
                );
              } catch (err) {
                console.error(err);
              }
              for (let groupIndex in selectedContactGroups) {
                let selectedGroup = selectedContactGroups[groupIndex];
                if (
                  !initialGroups
                    .map((group) => group.id)
                    .includes(selectedGroup.id)
                ) {
                  let group = [];
                  try {
                    group = await axios.post(
                      "/api/v2/companies/" +
                        companyId +
                        "/posts/" +
                        postId +
                        "/visible_email_lists",
                      {
                        email_list_id: selectedGroup.email_list_id,
                      }
                    );
                  } catch (err) {
                    console.log(err.stack);
                  }
                }
              }
              for (let groupIndex in initialGroups) {
                let selectedGroup = initialGroups[groupIndex];
                if (
                  !selectedContactGroups
                    .map((group) => group.id)
                    .includes(selectedGroup.id)
                ) {
                  let group = [];
                  try {
                    group = await axios.delete(
                      "/api/v2/companies/" +
                        companyId +
                        "/posts/" +
                        postId +
                        "/visible_email_lists/" +
                        selectedGroup.email_list_id
                    );
                  } catch (err) {
                    console.log(err.stack);
                  }
                }
              }
              if (
                showProfileDisplayOption.value === "private" ||
                showProfileDisplayOption.value === "contact_groups"
              ) {
                let visible_groups = [];
                try {
                  visible_groups = await axios.get(
                    "/api/v2/companies/" +
                      companyId +
                      "/posts/" +
                      postId +
                      "/visible_email_lists"
                  );
                } catch (err) {
                  console.log(err.stack);
                }

                setInitialGroups(
                  visible_groups.data.map((group) => {
                    return {
                      ...group,
                      label: group.display_name,
                      value: group.email_list_id,
                    };
                  })
                );
                setSelectedContactGroups(
                  visible_groups.data.map((group) => {
                    return {
                      ...group,
                      label: group.display_name,
                      value: group.email_list_id,
                    };
                  })
                );
              }

              setShowPostVisibilityOptionsModal(false);
              setSaving(false);
              toast.success("Sharing settings updated");
            }}
            disabled={saving}
          >
            {saving && (
              <BeatLoader
                size={5}
                color={"#ffffff"}
                loading={true}
              ></BeatLoader>
            )}
            {!saving && "Save"}
          </button>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default PostVisibilityOptionsModal;
